import React, { useState } from 'react';
import '../styles/Gallery.css'; // Importer le CSS global
import Modal from '../components/Modal';  // Importer le composant Modal

const Logequipeut = () => {
  const images = [
    '1.jpg',
    'loge1.jpg',
    'loge2.jpg',
    'loge3.jpg',
    'loge4.jpg',
    'loge5.jpg',
    'loge6.jpg',
       'loge8.jpg',


   

    // Ajoute ici toutes les autres images
  ];

  const [modalImage, setModalImage] = useState(null);  // État pour l'image du modal
  const [modalAltText, setModalAltText] = useState("");  // État pour le texte alternatif de l'image

  const openModal = (image, altText) => {
    setModalImage(image);
    setModalAltText(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText("");
  };

  return (
    <div className="album-detail">
      <h1>Album Loge qui peut</h1>
      <div className="image-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={`/album/logequipeut/${image}`}
            alt={`Détail de l'image ${index + 1}`}  // Descriptions concises pour l'accessibilité
            className="album-image"
            onClick={() => openModal(`/album/logequipeut/${image}`, `Détail de l'image ${index + 1}`)}  // Ouvre en grand
          />
        ))}
      </div>

      {/* Affichage du Modal lorsque l'image est cliquée */}
      {modalImage && <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />}
    </div>
  );
};

export default Logequipeut;
